<!--
  Created by Caroline on 2019/11/27 0027.
-->
<template>
  <div class="container" :class="show ? 'show' : ''">
    <div class="main">
      <template v-if="isAdjust">
        <div class="setting setting-font">
          <div class="setting--item click-unable">
            <div class="iconfont setting--icon">&#xe870;</div>
            <div class="setting--txt">字体大小</div>
          </div>
          <div class="font-wrap">
            <div class="font-item"
                 :class="{'active': globalFont.size === item.classname}"
                 @click="setGlobalFont({type: 'size', value: item.classname})"
                 v-for="item in fontArray">{{item.text}}</div>
            <div class="slice-line"></div>
            <div class="font-item"
                 :class="{'active': globalFont.bold}"
                 @click="setGlobalFont({type: 'bold', value: !globalFont.bold})">加粗</div>
            <button @click="toggleAdjustblock">完成</button>
          </div>
        </div>

      </template>
      <template v-else>
        <div class="title">{{detail.activity.title}}</div>
        <div class="setting">
          <div class="setting--item" @click="fullScreen">
            <div class="iconfont setting--icon">&#xe86b;</div>
            <div class="setting--txt">{{isFull ? '退出' : ''}}全屏</div>
          </div>
<!--          <div class="setting&#45;&#45;item" @click="fixScreen">-->
<!--            <div class="iconfont setting&#45;&#45;icon">&#xe86f;</div>-->
<!--            <div class="setting&#45;&#45;txt">{{isFix ? '取消固定' : '固定投屏状态'}}</div>-->
<!--          </div>-->
          <div class="setting--item" @click="toggleAdjustblock">
            <div class="iconfont setting--icon">&#xe870;</div>
            <div class="setting--txt">字体大小</div>
          </div>
        </div>
      </template>
    </div>

    <div class="toggle" @click="toggle">
      <div class="iconfont toggle--icon">&#xe86a;</div>
    </div>
  </div>
</template>

<script>
  import { lanchFullscreen, exitFullscreen } from '../lib/common';
  import {mapActions, mapState, mapGetters} from 'vuex'

  export default {
    name: "setting",
    data() {
      return {
        show: false,
        isFull: false,
        isFix: false,
        isAdjust: false,
        currentFontSize: 'fs-x',
        fontArray: [
          {
            text: '最小',
            classname: 'fs-s'
          },
          {
            text: '小',
            classname: 'fs-m'
          },
          {
            text: '标准',
            classname: 'fs-x'
          },
          {
            text: '大',
            classname: 'fs-xl'
          },
          {
            text: '最大',
            classname: 'fs-xll'
          }
        ]
      }
    },
    computed: {
      ...mapState(['activityId', 'detail', 'globalFont']),
    },
    watch: {
    },
    created() {
      this.setGlobalFont({
        type: 'size',
        value: this.currentFontSize
      })
    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
    },
    methods: {
      ...mapActions(['setGlobalFont']),
      fullScreen () {
        this.isFull = !this.isFull
        this.isFull ? lanchFullscreen(document.body) : exitFullscreen()
      },
      fixScreen () {
        this.isFix = !this.isFix
        this.$emit('fixScreen', this.isFix)
      },
      toggleAdjustblock () {
        this.isAdjust = !this.isAdjust
      },
      toggle () {
        this.show = !this.show
      },
      handleKeyup(event){
        const e = event || window.event || arguments.callee.caller.arguments[0]
        if(!e) return
        const {keyCode} = e
        // console.log(keyCode, key)
        if(keyCode === 27 && this.isFull){ // Esc 按键
          exitFullscreen()
          this.isFull = false
        }
      },
    }
  }
</script>

<style scoped lang="less">
  @import "../less/common.less";
  @import "../less/setting.less";

</style>



// WEBPACK FOOTER //
// src/components/setting.vue